import React, { useEffect, useState } from "react";
import "@/styles/components/heroSection.scss";
import Container from "@/components/container/Container";
import ButtonComponent from "@/components/button/Button";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const navigate = useNavigate();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const data = {
    heading: (
      <span>
        {windowWidth < 600 ? (
          <>
            <span>A</span> <span className="color-brand bold">direct helpline</span>{" "}
            <span>to buddies</span>
          </>
        ) : (
          "Got questions?"
        )}
      </span>
    ),
    // `${
    //   windowWidth < 768 ? `A direct helpline to buddies` : "Got questions?"
    // }`,
    subHeading: `${windowWidth < 600 ? `in universities abroad` : "We have the answers."}`,
    firstbutton: "Connect now",
    // secondbutton: "Need Help?",
    heroImage: `/assets/images/${windowWidth < 600 ? "inforens-hero" : "banner-img"}.png`,
  };

  const handleBookSession = () => {
    navigate("/guides");

    // if (isLoggedIn) {
    //   navigate("/guides");
    // } else {
    //   dispatch(setModalOpen(true));
    //   dispatch(setCurrentForm("signIn"));
    // }
  };

  // Modifying handleResize to update windowWidth state
  const handleResizeWithWidthUpdate = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResizeWithWidthUpdate);
    return () => {
      window.removeEventListener("resize", handleResizeWithWidthUpdate);
    };
  });

  return (
    <div className="heroSection-wrapper">
      <Container className="heroSection-container">
        <div className="content-wrapper">
          <div className="heading">{data.heading}</div>
          <div className="subheading">{data.subHeading}</div>
          <div className="button-container">
            <ButtonComponent
              className="button-container-first"
              varient="primary"
              size={"large"}
              label={data.firstbutton}
              onClick={handleBookSession}
            />
            {/* <ButtonComponent
              className="button-container-second"
              label={data.secondbutton}
              onClick={() => navigate("/faq")}
            /> */}
          </div>
        </div>
        <div className="hero-image">
          <img src={data.heroImage} alt="Hero Image" />
        </div>
      </Container>
    </div>
  );
};

export default HeroSection;
